<template>
    <div class="container">
        <div class="page-content">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark mb-1">
                        <img src="/assets/dipocaco/pocas/cards.png" alt="card-poca" class="page-poca">
                        {{ $t('myCards.heading') }} <span v-if="$store.getters.fullCardCollectionCount > 0 && !$store.state.markers.updatingCards"  class="ml-1 muted bg-light text-dark px-1 page-heading-counter">{{ $store.getters.fullCardCollectionCount }}</span>
                    </h1>
                </div>

                <div class="col-12 pb-1">
                    <a class="btn btn-sm btn-dark w-100" type="button" data-bs-toggle="offcanvas" data-bs-target="#my-card-options-canvas" aria-controls="my-card-options-canvas">
                        Filter <span class="fa-solid fa-filter"></span>
                    </a>
                </div>

                <div class="col-12 m-0 mb-1" v-if="filterBy !== ''">
                    <div class="alert alert-info mb-2">
                        <i18n-t keypath="myCards.showingFiltered" :plural="filteredCardCollectionCount">
                            <template #n>
                                {{ filteredCardCollectionCount }}
                            </template>
                        </i18n-t>
                    </div>
                </div>

                <div class="col-12 p-0" id="card-collection">
                    <div class="row">
                        <div v-if="$store.state.markers.updatingCards" class="col-12 text-center">
                            <loading-spinner/>
                        </div>

                        <template v-for="card in filteredCardCollection" v-if="!$store.state.markers.updatingCards && $store.state.collection.cards.length > 0">
                            <div :class="'col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 text-center collection-card '+($store.state.markers.selectingCards && card.isSelected === true ? 'card-is-selected' : '')">
                                <a href="javascript:" class="text-left mb-2" v-on:click="cardClick(card)" v-on:contextmenu.prevent="toggleSellingCards(card)">
                                    <img loading="lazy" :src="getSmallCardImageUrl(card)" style="width: auto; max-width: 100%;" class="card-thumbnail" alt="card-thumbnail">

                                    <div class="m-0 p-1 pt-0 card-short-info background-layered">
                                        <div class="m-0">
                                            <img v-if="card.types" v-for="type in card.types" :src="getTypeIcon(type)" alt="series-symbol" class="type-icon" :title="type">
                                            <span class="card-amount-display" v-if="card.amount > 1"><i class="fa-solid fa-copy"></i> {{ card.amount }}</span>
                                        </div>

                                        <div class="m-0">
                                            <img loading="lazy" :src="getRarityIcon(card)" alt="rarity-icon">
<!--                                            <img loading="lazy" v-if="card.is_in_set_collection" :src="getSetSymbolUrl(card)" alt="series-symbol">-->
                                            <img loading="lazy" v-if="!card.is_in_set_collection" src="/assets/dipocaco/icons/new.webp" alt="series-symbol" class="card-new-marker">
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </template>

                        <div v-if="!$store.state.markers.updatingCards && $store.state.collection.cards.length === 0" class="col-12">
                            <div class="alert alert-info mb-0">
                                {{ $t('myCards.empty') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="offcanvas offcanvas-start" tabindex="-1" id="my-card-options-canvas" aria-labelledby="my-card-options-canvas-label">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="my-card-options-canvas-label" v-text="$t('myCards.filter.heading')"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body row px-0 filter-buttons">
                <div class="col-12 mb-2">
                    <input type="search" class="form-control w-80" v-model="searchQuery" :placeholder="$t('myCards.filter.search')">
                </div>

                <div class="col-12 mb-2">
                    <label for="" v-text="$t('myCards.filter.sortBy')"></label>
                    <select v-model="sort_by" class="form-control" v-on:change="$store.commit('sortCollection', sort_by)" v-on:click="sort_by = ''">
                        <option value="pulldate" v-text="$t('myCards.filter.sortPulldate')"></option>
                        <option value="name" v-text="$t('myCards.filter.sortName')"></option>
                        <option value="dexnumber" v-text="$t('myCards.filter.sortDex')"></option>
                        <option value="type" v-text="$t('myCards.filter.sortType')"></option>
                        <option value="supertype" v-text="$t('myCards.filter.sortSupertype')"></option>
                        <option value="rarity" v-text="$t('myCards.filter.sortRarity')"></option>
                        <option value="set" v-text="$t('myCards.filter.sortSet')"></option>
                        <option value="artist" v-text="$t('myCards.filter.sortArtwork')"></option>
                        <option value="quantity" v-if="$store.getters.cardsWithDuplicates.length > 0" v-text="$t('myCards.filter.sortQuantity')"></option>
                        <option value="release" v-text="$t('myCards.filter.sortRelease')"></option>
                        <option value="price" v-text="$t('myCards.filter.sortPrice')"></option>
                    </select>
                </div>

                <div class="col-12 mt-2 mb-1">
                    <h3>
                        {{ $t('myCards.filter.filters') }}
                    </h3>
                </div>

                <div class="col-6">
                    <button :class="'btn btn-'+(filterBy === '' ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = ''" data-bs-dismiss="offcanvas" v-text="$t('myCards.filter.noFilter')"></button>
                </div>
                <div class="col-6">
                    <button :class="'btn btn-'+(filterBy === 'new' ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = 'new'" data-bs-dismiss="offcanvas"><img src="/assets/dipocaco/icons/new.webp" alt=""></button>
                </div>

                <div class="col-12 mb-0">
                    <h5 v-text="$t('myCards.filter.category')"></h5>
                </div>
                <div class="col-4">
                    <button :class="'btn btn-'+(filterBy === 'Pokémon' ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = 'Pokémon'" data-bs-dismiss="offcanvas" v-text="$t('myCards.filter.catPokemon')"></button>
                </div>
                <div class="col-4">
                    <button :class="'btn btn-'+(filterBy === 'Trainer' ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = 'Trainer'" data-bs-dismiss="offcanvas" v-text="$t('myCards.filter.catTrainer')"></button>
                </div>
                <div class="col-4">
                    <button :class="'btn btn-'+(filterBy === 'Energy' ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = 'Energy'" data-bs-dismiss="offcanvas" v-text="$t('myCards.filter.catEnergy')"></button>
                </div>

                <div class="col-12 mb-0">
                    <h5 v-text="$t('myCards.filter.type')"></h5>
                </div>
                <div class="col-2" v-for="type in getTypes()">
                    <button :class="'btn btn-'+(filterBy === type ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = type" data-bs-dismiss="offcanvas">
                        <img :src="getTypeIcon(type)" alt="">
                    </button>
                </div>

                <div class="col-12 mb-0">
                    <h5 v-text="$t('myCards.filter.rarity')"></h5>
                </div>
                <div v-for="rarity in getRarities()" :class="(rarity.search('Trainer')>=0 || rarity.search('Illustration')>=0) ? 'col-12' : 'col-6'">
                    <button :class="'btn btn-'+(filterBy === rarity ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = rarity" data-bs-dismiss="offcanvas">
                        {{ rarity }} <img :src="getRarityIconByRarity(rarity)" alt="rarity icon">
                    </button>
                </div>

                <div class="col-12 mb-0">
                    <h5 v-text="$t('myCards.filter.set')"></h5>
                </div>
                <div class="col-12 p-0" v-for="(sets, seriesName) in mainSets">
                    <h5 class="px-3">{{ seriesName }}</h5>
                    <div class="row p-0">
                        <div class="col-6" v-for="set in sets">
                            <button :class="'btn btn-'+(filterBy === set.set_id ? 'success' : 'dark')+' w-100 text-center px-0 filter-button'" v-on:click="filterBy = set.set_id" data-bs-dismiss="offcanvas">
                                <img :src="'/assets/dipocaco/sets/'+set.set_id+'/logo.png'" alt="set logo">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="userHasCollections" class="modal fade" id="collection-selection" tabindex="-1" aria-labelledby="#collection-selection-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="collection-selection-label" v-text="$t('myCards.collectionModal.selectCollection')"></h1>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <select name="" id="" class="form-control" v-model="selectedCollectionID">
                                <option v-for="collection in userCollections" :value="collection.id">{{ collection.name }}</option>
                                <option value="new">Create a new collection</option>
                            </select>
                        </div>

                        <div class="form-group mt-2" v-if="selectedCollectionID === 'new'">
                            <label for="newCollectionName">Name for new collection</label>
                            <input type="text" id="newCollectionName" v-model="newCollectionName" class="form-control">
                        </div>

                        <div class="form-check form-switch mt-2" v-if="selectedCollectionID === 'new'">
                            <label for="newCollectionDuplicates" class="form-check-label">Allow duplicates in new collection</label>
                            <input type="checkbox" v-model="newCollectionDuplicates" id="newCollectionDuplicates" class="form-check-input">
                        </div>

                        <div class="form-check form-switch mt-2" v-if="selectedCollectionID === 'new' ? newCollectionDuplicates : userCollections.find(c => c.id === selectedCollectionID).allow_duplicates">
                            <label for="moveAll" class="form-check-label">Move all of selected cards</label>
                            <input type="checkbox" v-model="moveAll" id="moveAll" class="form-check-input">
                        </div>

                        <div class="form-group mt-2">
                            <a href="javascript:" class="btn btn-sm btn-success float-end" v-on:click="confirmCollectionSelection" v-text="$t('myCards.collectionModal.moveCards')"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="marketplace-dialog" tabindex="-1" aria-labelledby="#marketplace-dialog-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="marketplace-dialog-label" v-text="$t('myCards.marketplaceDialog.putOnMarketplace')"></h1>
                    </div>

                    <div class="modal-body">
                        <p v-text="$t('myCards.marketplaceDialog.description')"></p>

                        <div class="form-group">
                            <label class="form-label" for="priceMultiplicator">{{ $t('myCards.marketplaceDialog.priceMultiplicator')}}: {{ priceMultiplicator > 0 ? (priceMultiplicator+'x') : 'FREE' }}</label>
                            <input type="range" class="form-range" id="priceMultiplicator" min="0" max="3" step="0.5" v-model="priceMultiplicator"/>
                        </div>

                        <div class="alert alert-danger" v-if="priceMultiplicator <= 0" v-text="$t('myCards.marketplaceDialog.freeWarning')"></div>

                        <div class="form-group mt-2">
                            <a href="javascript:" class="btn btn-sm btn-success float-end" v-on:click="confirmMarketplaceSelection" v-text="$t('myCards.marketplaceDialog.confirm')"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-action-bar" v-if="filteredCardCollection.length > 0">
            <template v-if="!$store.state.markers.selectingCards">
                <button v-if="!$store.state.markers.selectingCards" :class="'btn btn-info collection-action-button'" v-on:click="$store.commit('toggleSelectingCards')" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.selectCards')">
                    <i class="fa-solid fa-square-check"></i>
                </button>

                <template v-if="$store.getters.newCardsInCollection && !$store.state.markers.updatingCards">
                    <button v-if="!$store.state.markers.storingCardsInCollection" :class="'btn btn-danger collection-action-button'" v-on:click="storeNewCardsInCollection()" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.storeNew')">
                        <i class="fa-solid fa-star"></i>
                    </button>

                    <button v-else class="btn btn-danger" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.storingNew')">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </template>

                <template v-if="!$store.state.markers.updatingCards && $store.getters.cardsWithDuplicates.length > 0">
                    <button v-if="!$store.state.markers.sellingDuplicates" class="btn btn-success" v-on:click="$store.commit('sellAllDuplicates')" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.sellDuplicates')">
                        <i class="fa-solid fa-copy collection-action-button"></i>
                    </button>

                    <button v-else class="btn btn-success" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.sellingDuplicates')">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </template>
            </template>

            <template v-else>
                <button class="btn btn-info text-bold collection-action-button" v-on:click="$store.commit('toggleSelectingCards');" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.stopSelectingCards')">
                    <i class="fa-solid fa-square-check"></i>
                </button>

                <button class="btn btn-info text-bold collection-action-button"
                        v-on:click="$store.commit('markAllCardsForSale', filteredCardCollection)"
                        v-if="$store.getters.cardsForSale.length !== $store.state.collection.cards.length" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.all')">
                    <i class="fa-solid fa-check-double"></i>
                </button>

                <button class="btn btn-info text-bold collection-action-button"
                        v-else disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.all')">
                    <i class="fa-solid fa-check-double"></i>
                </button>

                <template v-if="!$store.state.markers.updatingCards">
                    <button v-if="$store.state.collection.cards.filter(c => c.isSelected).length > 0 && !$store.state.markers.sellingSelected" class="btn btn-success" v-on:click="$store.commit('sellSelectedCards')" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.sellSelected')">
                        <i class="fa-solid fa-hand-holding-dollar collection-action-button"></i>
                    </button>

                    <button class="btn btn-success"
                            v-if="$store.state.collection.cards.filter(c => c.isSelected).length === 0 && !$store.state.markers.sellingSelected" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.sellSelected')">
                        <i class="fa-solid fa-hand-holding-dollar collection-action-button"></i>
                    </button>
                </template>

                <template v-if="!$store.state.markers.updatingCards">
                    <button v-if="$store.state.collection.cards.filter(c => c.isSelected).length > 0 && !$store.state.markers.sellingSelected" class="btn btn-danger" v-on:click="openCollectionSelection" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.putInCollection')">
                        <i class="fa-solid fa-star"></i>
                    </button>

                    <button class="btn btn-danger" v-if="$store.state.collection.cards.filter(c => c.isSelected).length === 0 && !$store.state.markers.sellingSelected" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.putInCollection')">
                        <i class="fa-solid fa-star"></i>
                    </button>

                    <button v-if="$store.state.markers.sellingSelected" class="btn btn-success collection-action-button" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.sellingSelected')">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </template>

                <template v-if="!$store.state.markers.updatingCards">
                    <button v-if="$store.state.collection.cards.filter(c => c.isSelected).length > 0 && !$store.state.markers.sellingSelected" class="btn btn-danger" v-on:click="openMarketplaceDialog" data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.putInCollection')">
                        <i class="fa-solid fa-shop"></i>
                    </button>

                    <button class="btn btn-danger" v-if="$store.state.collection.cards.filter(c => c.isSelected).length === 0 && !$store.state.markers.sellingSelected" disabled data-bs-toggle="tooltip" data-bs-placement="left" :title="$t('myCards.putInCollection')">
                        <i class="fa-solid fa-shop"></i>
                    </button>
                </template>
            </template>
        </div>

        <card-detail-view-canvas :card="activeCard"/>
    </div>
</template>


<script>
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import CardService from "../../CardService.js";
import LoadingSpinner from "../parts/LoadingSpinner.vue";

export default {
    name: "MyCards",
    components: {LoadingSpinner, CardDetailViewCanvas},
   data() {
        return {
            loadingDone: false,
            searchQuery: '',
            activeCard: null,
            sort_by: 'pulldate',
            filterBy: '',
            mainSets: '',
            userCollections: [],
            selectedCollectionID: null,
            moveAll: false,
            newCollectionName: '',
            newCollectionDuplicates: false,
            userHasCollections: false,
            priceMultiplicator: 1,
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.$store.commit('updateUserCards');
        this.$store.commit('clearSelectedStatusFromCards');
        this.fetchUserCollections();
        this.fetchMainSets();

        setTimeout(() => {
            this.loadingDone = true;

            if (this.$store.state.collection.cards.length > 0) {
                this.activeCard = this.filteredCardCollection[0];
            }
        }, 500);
    },
    computed: {
        filteredCardCollection() {
            return this.$store.state.collection.cards.filter(card => {
                if (this.searchQuery.trim().length > 0 && !(card.name.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0
                    || (card.evolvesFrom && card.evolvesFrom.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0)
                    || (card.id.toLowerCase().search(this.searchQuery.toLowerCase()) >= 0))) {
                    return false;
                }

                if (this.filterBy.length > 0) {
                    if (this.filterBy === 'new') {
                        return card.is_in_set_collection !== true;
                    }

                    if (["Pokémon", "Trainer", "Energy"].includes(this.filterBy)) {
                        return card.supertype === this.filterBy;
                    }

                    if (CardService.getCardTypes().includes(this.filterBy)) {
                        return !(!card.types || !card.types?.includes(this.filterBy));
                    }

                    if (CardService.getCardRarityOrder().includes(this.filterBy)) {
                        return card.rarity === this.filterBy;
                    }

                    if (this.filterBy.length > 0) {
                        return card.set.id === this.filterBy;
                    }
                }

                return true;
            })
        },
        filteredCardCollectionCount() {
            let count = 0;
            this.filteredCardCollection.map(c => c.amount).forEach(s => count += Number((s ?? 1)));
            return count;
        },
        setsInCollection() {
            return this.$store.getters.setsInCollection;
        }
    },
    methods: {
        storeNewCardsInCollection() {
            this.$store.commit('storeNewCardsInCollection');
        },
        cardClick(card) {
            if (this.$store.state.markers.selectingCards) {
                // console.log(card.id);
                this.$store.commit('toggleCardForSale', card.id);
                this.$forceUpdate();
            } else {
                this.activeCard = card;
                this.$forceUpdate();

                setTimeout(() => {
                    $("#card-detail-view-canvas").offcanvas('toggle');
                }, 300)
            }
        },
        getSmallCardImageUrl(card) {
            return CardService.getSmallCardImageUrl(card);
        },
        getSetSymbolUrl(card) {
            return CardService.getSetSymbolUrl(card);
        },
        getTypeIcon(type) {
            return CardService.getTypeIcon(type);
        },
        getRarityIcon(card) {
            return CardService.getRarityIcon(card);
        },
        getRarityIconByRarity(rarity) {
            return CardService.getRarityIconByRarity(rarity.toLowerCase());
        },
        getRarities() {
            return CardService.getCardRarityOrder();
        },
        getTypes() {
            return CardService.getCardTypes();
        },
        fetchMainSets() {
            axios.get('/api/main-sets').then((response) => {
                this.mainSets = response.data;
            })
        },
        openCollectionSelection() {
            $('#collection-selection').modal('toggle');
        },
        confirmCollectionSelection() {
            if (this.selectedCollectionID === 'new' && this.newCollectionName.trim().length === 0) {
                iziToast.warning({title: 'Please define a name for your new collection'});
                return false;
            }

            $('#collection-selection').modal('toggle');

            this.$store.commit('addSelectedCardsToCollection', {
                selectedCollectionID: this.selectedCollectionID,
                moveAll: this.moveAll,
                newCollectionName: this.newCollectionName,
            });

            this.selectedCollectionID = this.userCollections[0]?.id ?? 'new';
            this.moveAll = false;
            this.newCollectionName = '';
            this.fetchUserCollections();
        },
        openMarketplaceDialog() {
            $('#marketplace-dialog').modal('toggle');
        },
        confirmMarketplaceSelection() {
            $('#marketplace-dialog').modal('toggle');

            this.$store.commit('addSelectedCardsToMarketplace', {
                priceMultiplicator: this.priceMultiplicator
            });

            this.priceMultiplicator = 1;
            this.fetchUserCollections();
        },
        fetchUserCollections() {
            axios.get('/api/collections/user').then(response => {
                this.userCollections = response.data ? Object.values(response.data) : [];
                this.userHasCollections = this.userCollections.length > 0;
                this.selectedCollectionID = this.userCollections[0]?.id ?? 'new';
            })
        },
        toggleSellingCards(card) {
            this.$store.commit('toggleCardForSale', card.id);

            if (!this.$store.state.selectingCards) {
                this.$store.commit('toggleSelectingCards');
            } else {
                this.$store.commit('toggleSelectingCards');
                this.$store.commit('clearSelectedStatusFromCards')
            }
        }
    },
    watch: {
        filterBy() {
            this.$forceUpdate();
        }
    }
}
</script>

<style lang="scss" scoped>
.page-heading {
    background-image: url("/assets/dipocaco/pocas/mycards-poca_sm.jpg");
    background-position: center 45%;
}

img {
    border-radius: 5px;
}

.row div {
    border: none;
    margin-bottom: 1em;
}

a {
    text-decoration: none;
}

.currency-icon {
    max-height: 2em;
}

.sell-button-row {
    .btn {
        white-space: nowrap;
        padding: 0.5em 0.1em;
    }
}

.form-control {
    max-width: 100%;
}

.form-check-input {
    border-radius: 15px;
}

.sell-marker {
    position: absolute;
    z-index: 50;
    display: block;
    margin-left: 0.8em;
    //margin-top: 1em;
    font-size: 4em;
    color: mediumspringgreen;
    backdrop-filter: blur(10px);
    border-radius: 30px;
}

.floater-sell-button {
    position: fixed;
    width: 100%;
    bottom: 5em;
    z-index: 100;

    display: flex;
    flex-direction: column;
    align-content: flex-end;
    align-items: flex-end;
    flex-wrap: nowrap;

    button {
        margin-top: 1em;
    }
}

.collection-card {
    padding-bottom: 0.5em !important;
}

.card-markers {
    font-size: 1.5em;
    font-weight: bold;
    //margin-top: -1em;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    display: flex;
}

.sort-button {
    text-align: center;
    padding-left: 0.2em;
    padding-right: 0.2em;
}

.collection-action-button {
    padding-left: 1px;
    padding-right: 1px;
    white-space: nowrap;
}

#card-collection {
    max-height: 55vh;
    overflow-y: auto;

    .row {
        align-items: center
    }
}

.card-is-selected {
    img.card-thumbnail {
        filter: drop-shadow(0px 4px 8px rgba(15, 253, 253, 0.47));
        opacity: 0.5;
        border-radius: 4%;
    }
}

.card-thumbnail {
    border-radius: 4%;
    padding-bottom: 1em;
}

.card-short-info {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .badge {
        margin-top: 0.5em;
    }

    img {
        height: 1.25em;
        margin-top: 0.5em;
    }

    .type-icon {
        margin-right: 0.25em !important;
    }

    .card-amount-display {
        vertical-align: middle;
        height: 1.5em !important;
        display: inline-block;
        padding-top: 0.3em;
        color: black;
    }
}

.card-new-marker {
    margin-left: 0.2em;
}


.filter-buttons {
    .filter-button {
        white-space: nowrap;

        img {
            max-height: 1.8em;
            max-width: 90%;
            border-radius: 0;
        }
    }
}

.card-counter {
    text-shadow: -2px 2px rgba(0,0,0,0.25);
}

.card-action-bar {
    text-align: right;
    position: fixed;
    bottom: 6em;
    right: 2.5em;
    display: flex;
    flex-direction: column-reverse;

    .btn {
        padding: 0.8em 1.2em;
        border-radius: 20px;
        margin-top: 1em;
    }
}
</style>
